/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// require('react-datetime/css/react-datetime.css')

// polyfills for phantomjs (which we should stab and kick)
// import "babel-polyfill"
// import 'core-js/es6/map';
// import 'core-js/es6/set';
// import 'core-js/fn/array/find';
// import 'core-js/fn/array/includes';
// import 'core-js/fn/number/is-nan';

import React from 'react'
import ReactDOM from 'react-dom'
import PurchasingButtonModal from 'products/purchasing_button_modal'

document.addEventListener('DOMContentLoaded', () => {
  const contentTag = document.getElementById('purchasing-modal-react')
  if (!contentTag) return

  const productId = contentTag.getAttribute('data-product-id')
  const saleProductUrl = contentTag.getAttribute('data-saleproduct-url')
  const hasSaleProduct = contentTag.getAttribute('data-has-saleproduct') === 'true'
  const buyNowPriceRange = JSON.parse(contentTag.getAttribute('data-buy-now-price-range'))

  ReactDOM.render(
    <PurchasingButtonModal
      productId={productId}
      saleProductUrl={saleProductUrl}
      hasSaleProduct={hasSaleProduct}
      buyNowPriceRange={buyNowPriceRange}
    />
    , contentTag
  )
})
